module.exports = "<toaster-container [toasterconfig]=\"config\"></toaster-container>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/@core/component/notifications/notifications.component.html
// module id = ../../../../../src/app/@core/component/notifications/notifications.component.html
// module chunks = main